export enum MasterDataTableNames {
    APPEAL = 'PER_APPEAL',
    AWARD = 'PER_AWARD',
    BANK = 'PER_BANK',
    CERTIFICATE = 'PER_CERTIFICATE',
    ADDRESS = 'PER_ADDRESS',
    CONTRACT = 'PER_CONTRACT',
    COURT = 'PER_COURT',
    DECLARATION_GOODS = 'PER_DECLARATION_GOODS',
    DEGREE = 'PER_DEGREE',
    EDUCATION = 'PER_EDUCATION',
    EXAM = 'PER_EXAM',
    EXPENDITURE = 'PER_EXPENDITURE',
    FOREIGN_LANGUAGE = 'PER_FOREIGN_LANGUAGE',
    HEALTH = 'PER_HEALTH',
    HISTORICAL_DATA = 'PER_HISTORICAL_DATA',
    IDENTIFICATION = 'PER_IDENTIFICATION',
    IDENTITY = 'PER_IDENTITY',
    MILITARY = 'PER_MILITARY',
    ORGANIZATION = 'PER_ORGANIZATION',
    PERSONAL_TITLE = 'PER_PERSONAL_TITLE',
    PHYSICAL_STANDARD = 'PER_PHYSICAL_STANDARD',
    SPECIAL_SITUATION = 'PER_SPECIAL_SITUATION',
    SYNDICATE = 'PER_SYNDICATE',
    TELEPHONE = 'PER_TELEPHONE',
    VEHICLE = 'PER_VEHICLE',
    WEAPON = 'PER_WEAPON',
    BORROWING = 'PER_BORROWING',
    ABSENCE_ENTRY = 'ABSENCE_ENTRY',
    ABSENCE_QUOTA = 'ABSENCE_QUOTA',
    MOVEMENT = 'PER_MOVEMENT',
    PUNISHMENT = 'PER_PUNISHMENT',
    SUSPENSION = 'PER_SUSPENSION_TIME',
    EXTERNAL = 'EXTERNAL',
    EXTERNAL_SERVICE = 'PER_EXTERNAL_SERVICE',
    ATTACHMENT = 'HRM_ATTACHMENT',
    ACADEMIC_TITLE = 'ACADEMIC_TITLE',
    COMPENSATION = 'PER_COMPENSATION',
    EXCEPTIONAL_RELATION = 'PER_EXCEPTIONAL_RELATION',
    CREDIBLE_EXPERIENCE = 'PER_CREDIBLE_EXPERIENCE',
    EXPERIENCE_MERGE = 'PER_EXPERIENCE_MERGE',
    ACCIDENT = 'PER_ACCIDENT',
    SECONDMENT = 'SECONDMENT',
    TERMINATION='TERMINATION',
    DISABILITY='PER_DISABILITY',
    EXPENSE_INFO='PER_EXPENSE_INFO',
    EXPERIENCE = 'PER_EXPERIENCE',
    FLAT_ALLOCATION = 'FLAT_ALLOCATION',
    OVERTIME = 'OVERTIME',
    PER_SKILL = 'PER_SKILL',
    PER_QUALITY = 'PER_QUALITY',

}
